import { generatePath } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as ROUTES from '#client/constants/routes';

import * as Styled from './AssistanceSection.style';

import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

function AssistanceSection() {
  const { productConfig } = useProductLandingContext();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const { assistance } = productConfig;

  if (!assistance) {
    return null;
  }

  const baseItem = {
    icon: assistance.icon ?? '/s2/material-icons/assistantrounded.svg',
    title: assistance.getInTouch,
    actions: assistance.actions,
    href: generatePath(ROUTES.help),
  };

  const extraItems = assistance.additionalAssistance || [];
  const items = [baseItem, ...extraItems];

  return (
    <Stack gap={4} marginBlockStart={4}>
      <Heading component="h2" size="xl" wrap="wrap">
        <FormattedMessage id={assistance.title} />
      </Heading>
      <Styled.ItemsStack gap={2} direction="column">
        {items.map((item) => (
          <Styled.ItemLink
            key={item.href}
            href={item.href}
            target="_blank"
            clickstreamProps={{
              ...personalizationClickstreamProps,
              elementName: 'assistance_link',
              elementPosition: 'assistance',
              destination: item.href,
              elementText: item.title,
            }}
          >
            <Styled.ItemCard>
              <Styled.ItemHeaderStack gap={2} direction="row" alignItems="center">
                <Box width={{ xs: '1.375rem', md: '2rem' }} height={{ xs: '1.375rem', md: '2rem' }}>
                  <SharedAsset alt="" aria-hidden src={item.icon} width="100%" height="100%" />
                </Box>
                <Text size="md" weight="medium" color="secondary">
                  <FormattedMessage id={item.title} />
                </Text>
              </Styled.ItemHeaderStack>
              <Text size="sm" color="blue" weight="medium">
                <FormattedMessage id={item.actions} />
              </Text>
            </Styled.ItemCard>
          </Styled.ItemLink>
        ))}
      </Styled.ItemsStack>
    </Stack>
  );
}

export default AssistanceSection;
